import { z } from 'zod';

export const fireBreachSchema = z.object({
  text: z.string().min(1),
  location: z.string(),
});

export type FireBreachSchema = z.infer<typeof fireBreachSchema>;
